import store from "../store/storeModules";
import { LOGGED_IN_USER } from '../constents/app';

export default function (to, from, next) {
    if (store.getters["user/LoggedInUserType"] === LOGGED_IN_USER) {
      return next();
    }
    next({name: "MyAccount", query: { redirect: to.fullPath }});
}